import gql from 'graphql-tag';

export const QUERY_LIST_CORPORATE_CLIENTS_TABLE = gql`
  query TableListCorporateClients(
    $where: WhereCorporateClientInput
    $pagination: PaginationInput
    $order: [OrderInput!]
  ) {
    tableListCorporateClients(
      where: $where
      pagination: $pagination
      order: $order
    ) {
      list {
        corporate_client_id
        name
        containers_amount
        assignments_amount
        status_id
        status_name
        uuid
      }
    }
  }
`;

export const QUERY_TOTAL_CORPORATE_CLIENTS = gql`
  query TotalCorporateClients($where: WhereCorporateClientInput) {
    totalCorporateClient(where: $where) {
      total
    }
  }
`;

export const QUERY_ONE_CORPORATE_CLIENT = gql`
  query OneCorporateClient($corporate_client_id: ID!) {
    getCorporateClient(corporate_client_id: $corporate_client_id) {
      corporate_client_id
      name
      short_name
      uuid
      lock_code
      locked
      enable_missing_container_detection
      config_parsed {
        payment_config {
          default_payment_processor_id
          login_name
          card_name
          refund_strategies {
            processor_id
            strategy
            email {
              to
              user_note
            }
          }
        }
      }
      userCorporateClients {
        created_on
        user {
          user_id
          email
          full_name
        }
      }
      clientLevels {
        client_level_id
        membershipLevel {
          name
        }
        clientRole {
          name
        }
        rent_duration_days
        rent_duration_max_days
        trial_length_days
        max_containers_per_month
        max_containers_at_a_time
        warning_email_amount
        locked_account_amount
        max_checkouts_per_day
      }
      status_id
      status {
        name
      }
      usefull_ae_id
      usefullAE {
        user_id
        full_name
        email
        adminRole {
          name
        }
      }
    }
  }
`;

export const MUTATION_UPDATE_CORPORATE_CLIENT = gql`
  mutation UpdateCorporateClient(
    $corporate_client_id: ID!
    $input: CorporateClientInput!
  ) {
    updateCorporateClient(
      corporate_client_id: $corporate_client_id
      input: $input
    ) {
      corporate_client_id
    }
  }
`;

export const QUERY_LIST_ASSIGNMENT_EXTENSIONS = gql`
  query ListAssignmentExtensions(
    $where: WhereAssignmentExtensionInput
    $pagination: PaginationInput
    $order: [OrderInput!]
  ) {
    listAssignmentExtension(
      where: $where
      pagination: $pagination
      order: $order
    ) {
      list {
        extension_id
        corporate_client_id
        days
        started_on
        started_by
        internal_note
        external_message
        end_date
        fees_voided
        fees_refunded
        assignments_extended
        started_by_user {
          full_name
        }
      }
    }
  }
`;

export const MUTATION_CREATE_ASSIGNMENT_EXTENSION = gql`
  mutation CreateAssignmentExtension($input: AssignmentExtensionInput!) {
    createAssignmentExtension(input: $input) {
      success
      error_message {
        message
        type
      }
    }
  }
`;

export const MUTATION_SET_CORPORATE_CLIENT_USEFULL_AE = gql`
  mutation SetCorporateClientUsefullAE(
    $corporate_client_id: ID!
    $user_id: ID!
  ) {
    setCorporateClientUsefullAE(
      corporate_client_id: $corporate_client_id
      user_id: $user_id
    ) {
      success
      error_message {
        message
        type
      }
    }
  }
`;

export const MUTATION_UPDATE_PAYMENT_CONFIG = gql`
  mutation UpdatePaymentConfig(
    $corporate_client_id: ID!
    $login_name: String
    $card_name: String
  ) {
    updatePaymentConfig(
      corporate_client_id: $corporate_client_id
      login_name: $login_name
      card_name: $card_name
    ) {
      success
      error_message {
        message
        type
      }
    }
  }
`;
